import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
export var SlideshowArrow = function (_a) {
    var className = _a.className, _b = _a.hidden, hidden = _b === void 0 ? false : _b, onClick = _a.onClick, onMouseOver = _a.onMouseOver, onMouseOut = _a.onMouseOut, orientation = _a.orientation;
    return (React.createElement("div", { className: className, onClick: onClick, onMouseOver: onMouseOver, onMouseOut: onMouseOut }, !hidden && (React.createElement(Icon, { icon: IdIcon.WhiteArrowIcn, styleId: IdStyles.IconExtraLarge, orientation: orientation }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/slideshow/SlideshowArrow.tsx
// module id = 2908
// module chunks = 3